import { AlertCircle, CheckCircle, Info, AlertTriangle } from "lucide-react";
import { Link } from "react-router";
import { useAuth } from "../../contexts/authContext";

const AlertBox = ({ message = "", type = "error", className="", children }) => {
  if (!message && !children) return null;
  let {user} = useAuth()

  const alertStyles = {
    error: "bg-red-100 border border-red-300 text-red-700",
    success: "bg-green-100 border border-green-300 text-green-700",
    warning: "bg-yellow-100 border border-yellow-300 text-yellow-700",
    info: "bg-blue-100 border border-blue-300 text-blue-700",
  };

  const icons = {
    error: <AlertCircle className="w-5 h-5 text-red-600" />,
    success: <CheckCircle className="w-5 h-5 text-green-600" />,
    warning: <AlertTriangle className="w-5 h-5 text-yellow-600" />,
    info: <Info className="w-5 h-5 text-blue-600" />,
  };

  return (
    <div
      role="alert"
      aria-live="assertive"
      className={`flex items-center gap-2 px-4 py-3 rounded-lg ${alertStyles[type]} ${className}`}
    >
      {icons[type]}
      <span className="font-medium">{message || children}</span>
      {message.toLowerCase().includes('please upgrade') && (
        <Link className="underline" to={`/${user.user_type}/subscription`}>upgrade</Link>
      )}
    </div>
  );
};

export default AlertBox;
